<template>
  <div>
    <div class="flex justify-between items-center">
      <label for="basis-file-input" class="label label__file w-full">
        <span v-if="basisFile">{{ basisFile.name }}</span>
        <span v-else>
          <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
            <use xlink:href="@/assets/v2/img/sprite.svg#icon__plus"></use>
          </svg>
          {{ label }}
        </span>
      </label>
      <button v-if="basisFile" class="flex-shrink-0 ml-4 icon" type="button"
              @click="clearFile">
        <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
          <use xlink:href="@/assets/v2/img/sprite.svg#icon__remove"></use>
        </svg>
      </button>
    </div>
    <input type="file"
           accept="application/pdf"
           id="basis-file-input"
           ref="basisFileInput"
           class="input__file hidden"
           @change="selectFile"/>
  </div>
</template>
<script>
export default {
  props: ['modelValue', 'label'],
  emits: ['update:modelValue'],
  data() {
    return {
      basisFile: null,
    }
  },
  watch: {
    modelValue(val) {
      this.basisFile = val
    }
  },
  methods: {
    selectFile(event) {
      this.basisFile = event.target.files[0]
      this.$emit('update:modelValue', this.basisFile)
    },
    clearFile() {
      this.basisFile = null
      this.$refs.basisFileInput.value = null
      this.$emit('update:modelValue', null)
    }
  }
}
</script>